import EmailIcon from '@mui/icons-material/Email';
import { Stack } from '@mui/material';
import PaiSpinningLoader from 'features/ui/base-components/pai-spinning-loader';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import { LinkedinContact, PerformanceComparison, Statistics } from './campaign-statistics-types';
import DayMessagesDialog from './day-messages-dialog';
import MessageHistory from './message-history';
import MessagePerformance from './message-performance';
import PerformanceComparisonTable from './performance-comparison-table';
import StatisticsSectionTitle from './statistics-section-title';

interface Props {
  performanceOfMessages: Statistics | undefined;
  timeZone: string | undefined;
  messageHistory: LinkedinContact[];
  performanceComparison: PerformanceComparison[];
  loading: boolean;
  contactDrawerLoading: boolean;

  campaignIdToName(id: string): string;

  handleOpenContactDrawer(linkedInURL: string, profileId?: string, funnelId?: string): () => void;
}

const StatisticsMessagesOverview: React.FC<Props> = ({
  performanceOfMessages,
  timeZone,
  messageHistory,
  performanceComparison,
  loading,
  contactDrawerLoading,
  campaignIdToName,
  handleOpenContactDrawer,
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  // Klick auf einen Balken im Diagramm: die Nachrichten dieses Tages und Schritts im Fenster (Simon 22.10.2026).
  const [bar, setBar] = useState<{ dateKey: string; stepName: string } | null>(null);

  return (
    <div className={classes.statisticsMessagesOverview}>
      {loading ? (
        <Stack className={classes.loadingContainer} justifyContent={'center'} alignItems={'center'}>
          <PaiSpinningLoader size={'large'} />
        </Stack>
      ) : null}
      <StatisticsSectionTitle icon={<EmailIcon />} title={t('comparePerformanceAcrossCampaigns')} />
      <Stack gap={2}>
        <MessagePerformance performanceOfMessages={performanceOfMessages} timeZone={timeZone} onBarClick={setBar} />
        <MessageHistory
          messageHistory={messageHistory}
          timeZone={timeZone}
          contactDrawerLoading={contactDrawerLoading}
          handleOpenContactDrawer={handleOpenContactDrawer}
        />
        <PerformanceComparisonTable performanceComparison={performanceComparison} campaignIdToName={campaignIdToName} />
      </Stack>
      <DayMessagesDialog
        bar={bar}
        messageHistory={messageHistory}
        timeZone={timeZone}
        campaignIdToName={campaignIdToName}
        onClose={() => setBar(null)}
        onOpenContact={(contact) => handleOpenContactDrawer(contact.linkedInURL ?? '', contact.profileIds?.linkedin, contact.funnelId)()}
      />
    </div>
  );
};

const useStyles = makeStyles()(() => ({
  statisticsMessagesOverview: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    marginTop: '8px',
  },
  loadingContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: '#FFF',
    opacity: 0.8,
    zIndex: 90,
  },
}));

export default StatisticsMessagesOverview;
